/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoZhuChaXunTiaoJian1,
  GuangGaoZhuChuangJianXinXi,
  GuangGaoZhuGengXinXinXi,
  GuangGaoZhuRiYuSuanGengXinXinXi,
  ResponseApiAdvertiserCreateRespDTO,
  ResponseApiBoolean,
  ResponseApiGuangGaoZhuXiangQing,
  ResponseApiIPageGuangGaoZhuLieBiao,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoZhuGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name AdvertiserListUsingPost
   * @summary 分页查询广告主列表
   * @request POST:/dsp-admin/api/advertiser
   * @secure
   */
  advertiserListUsingPost = (
    查询条件参数: GuangGaoZhuChaXunTiaoJian1,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoZhuLieBiao, void>({
      path: `/dsp-admin/api/advertiser`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name CreateAdvertiserUsingPost
   * @summary 创建广告主
   * @request POST:/dsp-admin/api/advertiser/create
   * @secure
   */
  createAdvertiserUsingPost = (
    createDTO: GuangGaoZhuChuangJianXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiAdvertiserCreateRespDTO, void>({
      path: `/dsp-admin/api/advertiser/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name UpdateAdvertiserDailyBudgetUsingPut
   * @summary 更新广告主日预算
   * @request PUT:/dsp-admin/api/advertiser/daily-budget
   * @secure
   */
  updateAdvertiserDailyBudgetUsingPut = (
    dailyBudgetUpdateDTO: GuangGaoZhuRiYuSuanGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/advertiser/daily-budget`,
      method: "PUT",
      body: dailyBudgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name GetAdvertiserUsingPost
   * @summary 获取广告主详情
   * @request POST:/dsp-admin/api/advertiser/{id}
   * @secure
   */
  getAdvertiserUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoZhuXiangQing, void>({
      path: `/dsp-admin/api/advertiser/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name UpdateAdvertiserUsingPut
   * @summary 更新广告主
   * @request PUT:/dsp-admin/api/advertiser/{id}
   * @secure
   */
  updateAdvertiserUsingPut = (
    createDTO: GuangGaoZhuGengXinXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/advertiser/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuGuanLi
   * @name DeleteAdvertiserUsingDelete
   * @summary 删除广告主
   * @request DELETE:/dsp-admin/api/advertiser/{id}
   * @secure
   */
  deleteAdvertiserUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/advertiser/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoZhuGuanLi();
